export const customsShipmentStatus: any = {
  FOREIGN_ORDER: {
    next: ['ARRIVED_CUSTOMS'],
    name: 'Гадаад захиалга бүртгэгдсэн',
  },
  ARRIVED_CUSTOMS: {
    next: ['CUSTOMS_CLEARANCE'],
    name: 'Гаалийн бүрдүүлэгч хүлээн авсан',
  },
  CUSTOMS_CLEARANCE: {
    next: ['CUSTOMS_PENDING'],
    name: 'Гаальд мэдүүлсэн',
  },
  CUSTOMS_PENDING: {
    next: ['CUSTOMS_COMPLETE'],
    name: 'Гаалийн бүрдүүлэлт дууссан',
  },
  CUSTOMS_COMPLETE: {
    next: [],
    name: 'Гаалийн байгууллагаас хүлээн авсан',
  },
  CUSTOMS_FAILED: {
    next: ['CUSTOMS_COMPLETE'],
    name: 'Гаальд хураагдсан',
  },
};
